import { useEffect, useState } from "react";
import { Button, Container, Form, Row, Col, Alert } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { getMembers } from "../../controllers/user";
import { useAuth } from "../auth/AuthProvider";
import { addTeamMembers } from "../../controllers/org";

function EquipoAddMembers({ teamId, etapaId, comunidadId, onEquiperoAddition }) {
  const [equiperos, setEquiperos] = useState([]);
  const [equiperosOptions, setEquiperosOptions] = useState([]);
  const [alert, setAlert] = useState();
  const { token } = useAuth();

  useEffect(() => {
    loadMembers()
  }, []);

  async function loadMembers() {
    const d = await getMembers(token, {
      comunidad: comunidadId,
      etapa: etapaId
    });
    let options = d.rows.filter(m => !m.team_member);
    setEquiperosOptions(options);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    console.log(equiperos);
    try {
      const membershipIds = equiperos.map(m => m.membership_id);
      await addTeamMembers(teamId, membershipIds);
      if (typeof onEquiperoAddition === 'function') {
        onEquiperoAddition(equiperos);
      }
      loadMembers();
      setEquiperos([]);
      setAlert(<Alert variant="success">
        <p>Se agregaron nuevos miembros al equipo correctamente.</p>
      </Alert>);
    }
    catch(e) {
      setAlert(<Alert variant="danger">
        <p>Ocurrió un error al agregar miembros. Intenta de nuevo más tarde.</p>
      </Alert>);
    }
  }

  return <Container className="mb-5">
    <h1>Agregar miembros</h1>
    
    {alert}

    <Form onSubmit={handleSubmit}>
      <Row>
        <Col lg={6}>
          <Typeahead
            id="equiperos"
            labelKey="label"
            onChange={(selected) => {
              setEquiperos(selected);
            }}
            options={equiperosOptions}
            placeholder="Selecciona a los equiperos"
            renderMenuItemChildren={(option) => (
                <span>{option.label}</span>
            )}
            selected={equiperos}
            multiple={true}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col sm={3}>
          { !!equiperos.length && <Button type="submit">Agregar</Button> }
        </Col>
      </Row>
    </Form>
    
  </Container>;
}

export default EquipoAddMembers;
